// api
import type { PostEnergyTreeNodeDto } from '@/api/generated/recalc/endpoints/v2/energyGroups';

// feature-utils
import { mapUnitsToDataStreams } from '@/features/energyxplorer/utils/energyTreeFunctions';

// relative
import type {
  CreateFirstNodeFormValues,
  OpeningHoursValue,
} from './createFirstNodeForm.schema';

const DEFAULT_OPENING_HOURS: OpeningHoursValue = {
  monday: [{ start: 7, end: 17 }],
  tuesday: [{ start: 7, end: 17 }],
  wednesday: [{ start: 7, end: 17 }],
  thursday: [{ start: 7, end: 17 }],
  friday: [{ start: 7, end: 17 }],
  saturday: [],
  sunday: [],
};

export function toCreateFirstNodeFormValues(
  groupName?: string | null,
): CreateFirstNodeFormValues {
  return {
    name: groupName ? `${groupName} - Hovedmåler` : '',
    units: [],
    openingHours: DEFAULT_OPENING_HOURS,
  };
}

export function toPostEnergyTreeNodeDto(
  values: CreateFirstNodeFormValues,
): PostEnergyTreeNodeDto {
  return {
    name: values.name.trim(),
    type: 'Hovedmåler',
    parentId: null,
    dataStreams: mapUnitsToDataStreams(values.units),
    options: {
      consumption: null,
      percentage: null,
      openingHours: values.openingHours,
      goShares: [],
    },
  };
}
